import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class CurrencyConversionOrganizationContextModel extends Model {
  [Type] = 'currency-conversion/organization-context' as const;

  @attr('string') declare defaultCurrency: string | null;
}
